var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCimb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 722.29 110.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#790008;}.cls-2{fill:#fff;}.cls-3{fill:#ed3024;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_790008ff",
    "data-name": "#790008ff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0H110.2q0,55.1,0,110.19H0V0M14.68,20.69C23.25,32.17,32,43.55,40.57,55,32,66.5,23.27,77.84,14.72,89.33c19.56.08,39.11,0,58.67,0C82.19,78,90.67,66.34,99.54,55h-.17q-13-17.18-25.93-34.33C53.85,20.69,34.26,20.65,14.68,20.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.54,32.2a38.11,38.11,0,0,1,54.63-4.74q-5,5.1-10.13,10.14a23.45,23.45,0,0,0-20.87-4.45A22.91,22.91,0,0,0,155,50.09c-2.17,8.71,1,18.62,8.14,24.14,8.19,6.7,20.89,6.36,28.94-.41,3.37,3.38,6.82,6.7,10.11,10.18a38.11,38.11,0,0,1-53.75-3.67,37.36,37.36,0,0,1-.91-48.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.56,20.17h14.5q0,35.6,0,71.19c-4.84,0-9.67,0-14.51,0Q215.58,55.77,215.56,20.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.41,20c4.7,0,9.4,0,14.11,0,8.38,15.07,16.55,30.28,25,45.31,8.23-15.13,16.58-30.18,24.81-45.3H325.6c0,23.74,0,47.47,0,71.21-4.83-.07-9.65,0-14.48,0,0-14,0-28.09,0-42.14-8.32,14.2-16.24,28.64-24.7,42.74C278.32,77.48,270,63.32,261.9,49.05q0,21.08,0,42.14h-14.5Q247.38,55.61,247.41,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.11,20.17h29.36a25.14,25.14,0,0,1,13,3.5c9.35,5.71,11.49,20.54,3.69,28.39a22.57,22.57,0,0,1-3.37,2.8,16.54,16.54,0,0,1,8.69,11.69c1.21,6.75-.33,14.49-5.56,19.26-4.18,4-10.11,5.43-15.74,5.5-10,.11-20.08,0-30.12,0q0-35.6,0-71.19m14.5,13c0,5.16,0,10.33,0,15.5,4.26,0,8.54,0,12.81,0,2.49,0,5.18-.56,7-2.4a8.19,8.19,0,0,0,.35-10.33c-1.77-2.12-4.69-2.78-7.33-2.77H356.61m0,28.51c0,5.5,0,11,0,16.5,4.71,0,9.43,0,14.14,0a8.22,8.22,0,0,0,6.18-14.31c-1.82-1.72-4.42-2.17-6.83-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M423.62,20c2.42,0,4.84-.08,7.26,0,1.11.86,1.73,2.2,2.62,3.28C446.78,41.48,460,59.7,473.31,77.8q0-28.9,0-57.79h7.5V91c-2.53,0-5.06,0-7.58,0q-21-29-42.1-57.89V91c-2.52,0-5,0-7.55,0C423.69,67.32,423.6,43.67,423.62,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M499.48,20H507V91c-2.5,0-5,0-7.49,0Q499.46,55.51,499.48,20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M518.53,91.51q13-35.52,26-71c3.47,0,6.93,0,10.4,0Q567.31,55.76,579.71,91h-8.84q-3.29-9.43-6.68-18.84H534.81c-2.18,6.43-4.29,12.91-6.48,19.34-3.27,0-6.53,0-9.8,0m19.28-27.84c7.8,0,15.6,0,23.4,0q-5.87-17.08-11.61-34.21C545.69,40.88,541.69,52.26,537.81,63.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M596.36,32.13c5.92-6.1,13.84-10.48,22.38-11.26,10.53-1.06,21,2.84,29.53,8.84-1.66,2.15-3.4,4.23-5,6.39-2.84-4-7.86-5.54-12.39-6.76-7.87-2.17-16.81-1-23.46,3.9A32,32,0,0,0,595.76,52c-.9,7.55-.16,15.79,4.33,22.18,1.54,2.42,4,4,6.09,5.84a24.93,24.93,0,0,0,16,5.23,50.7,50.7,0,0,0,20.35-4.48c0-7.29,0-14.59,0-21.89H625.85V52.2c7.89,0,15.77,0,23.67,0q0,16.92,0,33.84c-7.53,4.2-16.16,6-24.66,6.81-9,.18-18.39-2.12-25.39-8-6.84-5.62-10.84-14.18-12-22.84C586.57,51.44,589.25,40.2,596.36,32.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M661.56,91.43q13-35.43,26-70.92c3.47,0,6.93,0,10.41,0,8,22.44,15.76,45,23.7,67.4a11.56,11.56,0,0,1,.66,3.14h-8.35c-2.26-6.26-4.46-12.56-6.69-18.84q-14.75,0-29.48,0c-2.11,6.45-4.3,12.87-6.42,19.31-3.26,0-6.53.11-9.79-.08m31-61.91c-3.86,11.41-7.9,22.76-11.73,34.19,7.76,0,15.54,0,23.31,0C700.39,52.28,696.47,40.91,692.59,29.52Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_ffffffff",
    "data-name": "#ffffffff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.68,20.69c19.58,0,39.17,0,58.76,0Q86.37,37.85,99.37,55q-29.4.06-58.8,0C32,43.55,23.25,32.17,14.68,20.69Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_ed3024ff",
    "data-name": "#ed3024ff"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.57,55q29.4,0,58.8,0h.17C90.67,66.34,82.19,78,73.39,89.37c-19.56,0-39.11,0-58.67,0C23.27,77.84,32,66.5,40.57,55Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCimb);
export default __webpack_public_path__ + "static/media/cimb.ec3e91ec60fdac39977ff7655a02b84a.svg";
export { ForwardRef as ReactComponent };